import { z } from "zod";
export const DEFAULT_BLOG_AUTHOR_ID = "anvith-murthy";
export function blogAuthorId(assigned?: string | null): string {
  return assigned ?? DEFAULT_BLOG_AUTHOR_ID;
}
export const blogSlug = z.string().min(1).max(120).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
export const httpsUrl = z.string().url().max(2000).refine((value) => {
  const url = new URL(value);
  return url.protocol === "https:" && !url.username && !url.password;
});
export const blogAuthorInput = z.object({
  id: blogSlug, name: z.string().trim().min(1).max(200),
  kind: z.enum(["person", "organization"]),
  bio: z.string().trim().min(1).max(2000), photo_url: httpsUrl,
  role: z.string().trim().max(200).default(""),
  profile_url: httpsUrl.nullable().default(null), active: z.boolean().default(true),
}).strict();
export const blogCreditInput = z.object({ slug: blogSlug, author_id: blogSlug, cover_image_url: httpsUrl.nullable().default(null) }).strict();
export const unpublishArticleInput = z.object({ slug: blogSlug, status: z.literal("draft") }).strict();
export type BlogAuthorRecord = z.infer<typeof blogAuthorInput>;
/** Social-share (og:image) default stays JPG; on-page default is the WebP twin. */
export const DEFAULT_BLOG_COVER = "https://leadxkids.com/leadxkids-social-banner-2026-10.jpg";
export const DEFAULT_BLOG_COVER_WEBP = "https://leadxkids.com/leadxkids-social-banner-2026-10.webp";

/** Site-hosted WebP files whose JPG/PNG twin lives at the same path in public/. */
const SITE_RASTER_TWINS: Record<string, string> = {
  "/leadxkids-social-banner-2026-10.webp": ".jpg", "/og-assessment.webp": ".jpg", "/og-confidence-check.webp": ".jpg",
  "/og-learning-journeys.webp": ".jpg", "/og-subscription.webp": ".jpg", "/lx-logo-new.webp": ".png", "/lx-logo-new-icon.webp": ".png",
};

/** Known JPG/PNG twin for a leadxkids.com WebP URL, else null (no network). */
export function siteRasterTwin(url: string): string | null {
  try {
    const u = new URL(url);
    if (!/^(www\.)?leadxkids\.com$/.test(u.hostname)) return null;
    const ext = SITE_RASTER_TWINS[u.pathname];
    return ext ? `${u.origin}${u.pathname.replace(/\.webp$/, ext)}` : null;
  } catch { return null; }
}

/** Social image: stored twin, else known site twin, else the cover as given. */
export function shareImage(cover: string, storedOg?: string | null): string {
  return storedOg || (/\.webp$/i.test(cover) ? siteRasterTwin(cover) : null) || cover;
}